import TouchAndMobile from './Fragment/TouchAndMobile';
import State from './Fragment/State';
import focusWithin from './Fragment/FocusWithin';
import Headroom from 'headroom.js';

const SEARCH_INPUT = document.querySelector('.header-search__input');
const HTML_CLASS_LIST = document.documentElement.classList;
const SEARCH_ACTIVE_CLASS = '-search-active';
const HEADER = document.querySelector('.header');
const MOBILE_OPEN_CLASS = 'main-nav__link--open';
const SETTINGS = {
    namespace: 'main-nav',
    header: '.header'
};

focusWithin(document);

if (HEADER) {
    const headroom = new Headroom(HEADER, {
        // vertical offset in px before element is first unpinned
        offset: 5,
        // scroll tolerance in px before state changes
        tolerance: 5,
        onUnpin: () => {
            HTML_CLASS_LIST.remove(SEARCH_ACTIVE_CLASS);
        }
    });
    headroom.init();
    new State(SETTINGS);
    let menu = new TouchAndMobile(SETTINGS);
    window.menu = menu;

    HEADER.addEventListener('click', event => {
        const TARGET = event.target;
        if (menu.isOpen() && TARGET.classList.contains('main-nav__link--sub')) {
            event.preventDefault();
            const LIST = TARGET.nextElementSibling;
            const IS_OPEN = TARGET.classList.contains(MOBILE_OPEN_CLASS);
            const HEIGHT = [...LIST.children].reduce((total, children) => children.offsetHeight + total, 0);
            LIST.style.height = `${HEIGHT}px`;
            setTimeout(() => {
                TARGET.classList.toggle(MOBILE_OPEN_CLASS);
            }, 0);

            if (IS_OPEN) {
                // Close also all submenus
                closeSubmenus(LIST);
            }
            // after the transition, we set the height to auto
            setTimeout(() => {
                LIST.style.height = 'auto';
            }, 400);
        }
    });

    document.addEventListener('mobileMenu.open', () => {
        [...HEADER.querySelectorAll('.main-nav__link--sub')].forEach(item => item.setAttribute('aria-role', 'button'));
    });

    document.addEventListener('mobileMenu.close', () => {
        closeSubmenus(HEADER);
        [...HEADER.querySelectorAll('.main-nav__link--sub')].forEach(item => item.removeAttribute('aria-role'));
    });
}

function closeSubmenus(parent) {
    [...parent.querySelectorAll(`.${MOBILE_OPEN_CLASS}`)].forEach(item => item.classList.remove(MOBILE_OPEN_CLASS));
}

document.addEventListener('click', event => {
    if (event.target.classList.contains('header__search')) {
        HTML_CLASS_LIST.toggle(SEARCH_ACTIVE_CLASS);
        if (HTML_CLASS_LIST.contains(SEARCH_ACTIVE_CLASS)) {
            SEARCH_INPUT.focus();
        }
    }
});
